import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import { Chart } from "react-google-charts";
import NoData_Orion from "./NoData_Orion";
import ChartLoader_Orion from "./ChartLoader_Orion";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import BucketDischarge_Orion from "./BucketDischarge_Orion";
import WaterMark from "../../Dashboard/DashboardMain/WaterMark";

export default function SocDischargeCycle_Orion({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;

  const appyData = (data) => {
    const res_result = data;
    let responce = {
      "<=20": 0,
      40: 0,
      60: 0,
      80: 0,
      100: 0,
    };
    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;
      temp_result.map((d) => {
        let value = d.median_dischargeSoc.values["50.0"];
        if (value <= 20) {
          responce["<=20"] = responce["<=20"] + 1;
        } else if (value > 20 && value <= 40) {
          responce["40"] = responce["40"] + 1;
        } else if (value > 40 && value <= 60) {
          responce["60"] = responce["60"] + 1;
        } else if (value > 60 && value <= 80) {
          responce["80"] = responce["80"] + 1;
        } else if (value > 80 && value <= 100) {
          responce["100"] = responce["100"] + 1;
        }
        // else if (value >= 240) {
        //   responce[">240"] = responce[">240"] + 1;
        // }
      });
      let res_result_final = [["Element", "Count", { role: "style" }]];
      let loop_keys = Object.keys(responce);
      loop_keys = ["<=20", "40", "60", "80", "100"];
      loop_keys.map((x) => {
        // res_result_final.push([x, responce[x], "#83A4CF"]);
        res_result_final.push([
          x,
          responce[x],
          "stroke-width: 1;stroke-color: black;",
        ]);
      });
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  };

  const options = {
    hAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Average Soc Discharge",
      minValue: 0,
      format: "short",
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
    },
    vAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Vehicle Count",
      minValue: 0,
      format: "short",
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "orion_drive_api/" + apiend, body: { filterdata: gloablfilter }, }, appyData);
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox chartbox_bus">
        <div className="titlebg_orion text-fit">{title}</div>
        <div className="chartHGT">
          <WaterMark />
          {isLoading ? (
            <ChartLoader_Orion />
          ) : chartdata.length == 0 ? (
            <NoData_Orion />
          ) : (
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="240px"
              data={chartdata}
              options={options}
              chartEvents={[
                {
                  eventName: "select",
                  callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length === 1) {
                      const [selectedItem] = selection;
                      const { row } = selectedItem;

                      const barvalue =
                        chartWrapper.getDataTable().Wf[row].c[0].v;
                      const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                      if (count != 0) {
                        let filtered_temp = [];
                        filtered_temp = apiresponce.filter((x) => {
                          if (
                            x.median_dischargeSoc.values["50.0"] <= barvalue &&
                            x.median_dischargeSoc.values["50.0"] > barvalue - 20
                          ) {
                            return x;
                          } else if (
                            x.median_dischargeSoc.values["50.0"] >= 100 &&
                            barvalue === ">100"
                          ) {
                            return x;
                          } else if (
                            x.median_dischargeSoc.values["50.0"] <= 20 &&
                            barvalue === "<=20"
                          ) {
                            return x;
                          }
                        });

                        function compareObjects(object1, object2, key) {
                          const obj1 =
                            object1.median_dischargeSoc.values["50.0"];
                          const obj2 =
                            object2.median_dischargeSoc.values["50.0"];
                          if (obj1 > obj2) {
                            return -1;
                          }
                          if (obj1 < obj2) {
                            return 1;
                          }
                          return 0;
                        }

                        filtered_temp.sort((value1, value2) => {
                          return compareObjects(value1, value2, "vehicalId");
                        });

                        SetfilteredData((prestate) => filtered_temp);
                        window.$("#exampleModal__" + apiend).modal("show");
                      }
                    }
                  },
                },
              ]}
            />
          )}

          <div
            className="modal fade"
            id={"exampleModal__" + apiend}
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {modal_title}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
                <div className="modal-body">
                  {/* <table className="table table-striped">
                    <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                      <tr>
                        <th scope="col">Vin Number</th>
                        <th scope="col">value</th>
                      </tr></thead>
                    <tbody> */}
                  <BucketDischarge_Orion data={filteredData} />
                  {/* </tbody></table> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
